export enum HoneyOperationName {
  SearchAutoComplete = 'web_paypal_search_autocomplete',
  GetPopularStores = 'web_paypal_dashboard_getPopularStores'
}
